import { render } from "./FacturacionEstadoFactura.vue?vue&type=template&id=0ab222cf&scoped=true"
import script from "./FacturacionEstadoFactura.vue?vue&type=script&lang=js"
export * from "./FacturacionEstadoFactura.vue?vue&type=script&lang=js"

import "./FacturacionEstadoFactura.vue?vue&type=style&index=0&id=0ab222cf&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab222cf"]])

export default __exports__